<template>
  <div class="financial-center">
    <div class="flex-1">
      <header>
        <h1>财务中心</h1>
        <div class="more" @click="handleSaveBtnClick('/base')">
          <span>财务中心</span>
          <i class="el-icon-arrow-right" />
        </div>
      </header>
      <div class="flex">
        <div class="content-l flex-1">
          <vuescroll :ops="$store.state.vueScrollOps" style="height:auto;">
            <div class="box" style="border:0;">
              <h2>服务账户-账户余额</h2>
              <div class="balance-warp">
                <div class="balance-text">
                  <div class="balance-text-l">
                    <span>账户余额：</span>
                    <div class="btn" @click="handleSaveBtnClick('/base')">
                      充值
                    </div>
                  </div>
                  <div class="flex price">
                    <span>¥</span>
                    <countTo
                      :start-val="0"
                      :end-val="info.cashAccount / 100"
                      :duration="2000"
                      :decimals="2"
                    />
                    <span>元</span>
                  </div>
                </div>
                <div class="balance-wrap-r flex">
                  <div :key="index">
                    <div class="title">
                      <i />
                      <span class="title-text">ETC积分</span>
                    </div>
                    <p class="price">
                      {{ (info.etcIntegralAccount / 100).toFixed(2) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </vuescroll>
          <!-- <vuescroll :ops="$store.state.vueScrollOps">
                        <div
                            class="box oil"
                            style="height:212px;"
                        >
                            <h2 v-if="false">
                                油品账户
                            </h2>
                            <div
                                v-if="false"
                                class="balance-warp flex"
                            >
                                <div class="balance-text">
                                    <div class="balance-text-l">
                                        <span>可用余额：</span>
                                        <div class="btn">
                                            充值
                                        </div>
                                    </div>
                                    <div class="flex price">
                                        <span>¥</span>
                                        <countTo
                                            :start-val="0"
                                            :end-val="0"
                                            :duration="2000"
                                            :decimals="2"
                                        />
                                        <span>元</span>
                                    </div>
                                </div>
                                <div class="balance-wrap-r flex">
                                </div>
                            </div>
                        </div>
                    </vuescroll> -->
        </div>
        <div class="content-r flex-1">
          <div>
            <h2>可开发票</h2>
            <vuescroll :ops="$store.state.vueScrollOps">
              <li :key="index">
                <div class="l">
                  <h3>牛卡福企业服务</h3>
                  <div class="price flex">
                    <span>¥</span>
                    <span>{{ (info.invoiceAccount / 100).toFixed(2) }}</span>
                    <span>元</span>
                  </div>
                </div>
              </li>
              <div class="r">
                <h3>服务费发票</h3>
                <span @click="handleSaveBtnClick('/base/invoice/overview/index')">
                  索取发票
                </span>
              </div>
            </vuescroll>
          </div>
        </div>
      </div>
    </div>
    <nf-confirm :show.sync="show">
      <div slot="content">
        <div class="titleHeader">
          <div class="left">
            <img src="../../images/lhv2DA.png" class="transform" />
            <span
              style="display:inline-block;transform: translate(0px,-10px);fontSize:16px;color:hsla(0, 0%, 40%, 1)"
            >
              |
            </span>
            <div
              style="display:inline-block;transform: translate(0px,-10px);fontSize:14px;marginLeft:8px;fontWeight:650"
            >
              企业实名认证
            </div>
          </div>
        </div>
        <div class="matter">
          <p class="titleP">
            亲爱的企业管理员您好：
          </p>
          <p class="titlep">
            您的企业尚未进行企业实名认证，请点击下方认证按钮，<b>3分钟立即认证</b>，即可使用全部功能。
          </p>
        </div>
      </div>
      <div slot="footer">
        <span v-throttle="2000" class="blue" @click="handleToUrl">
          立即认证
        </span>
        <span class="anout" @click="show = false">
          忽略
        </span>
      </div>
    </nf-confirm>
  </div>
</template>
<script>
import vuescroll from 'vuescroll';
import countTo from 'vue-count-to';
import store from '@/store/index';
export default {
  components: {
    vuescroll,
    countTo,
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    corpCertityStatus() {
      return store.state.corpCertityStatus;
    },
    admin() {
      return store.state.admin;
    },
    creator() {
      return store.state.creator;
    },
    info() {
      return store.state.accountInfo;
    },
    corporationInfo() {
      return store.state.corporationInfo;
    },
  },
  watch: {
    corporationInfo: {
      handler(n) {
        store.commit('updateCorporationInfo', n);
      },
    },
  },
  methods: {
    handleToUrl() {
      if (this.creator) {
        window.open(window.location.origin + '/admin/location/index');
      } else {
        window.open(window.location.origin + '/admin/authentication/index');
      }
    },
    handleSaveBtnClick(val) {
      if (!this.corpCertityStatus) {
        if (this.admin) {
          this.show = true;
        } else if (!this.admin) {
          this.$message({
            message:
              '您的企业尚未完成实名认证，请联系管理员' +
              this.corporationInfo.administrator +
              ':' +
              this.corporationInfo.administratorPhone +
              '进行企业实名认证',
            type: 'warning',
            showClose: true,
          });
        }
      } else {
        window.open(window.location.origin + val);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import url('./right.css');
.financial-center {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
  box-shadow: 0px 0px 7px 0px rgba(214, 214, 214, 0.5);
  .box {
    padding: 17px 0 10px 20px;
    border-top: 1px solid #f1f6ff;
    height: 260px;
    box-sizing: border-box;
  }
  h2 {
    height: 22px;
    font-size: 16px;
    font-weight: 500;
    color: rgba(18, 28, 64, 1);
    line-height: 22px;
    margin-bottom: 15px;
  }
  .content-l {
    border-right: 1px solid #f1f6ff;
    border-bottom: 1px solid #f1f6ff;
  }
  .balance-text {
    width: 280px;
    height: 118px;
    border-radius: 10px;
    background: linear-gradient(131deg, rgba(112, 113, 137, 1) 0%, rgba(50, 51, 82, 1) 100%);
    border-radius: 10px;
    background-size: cover;
    padding: 21px;
    box-sizing: border-box;
    position: relative;
    margin-right: 45px;
    .price {
      font-size: 26px;

      font-weight: 600;
      cursor: zoom-in;
      // cursor:zoom-out;
      color: rgba(255, 255, 255, 1);
      // line-height:37px;
      align-items: flex-end;
      span:nth-child(1) {
        font-size: 18px;

        font-weight: 500;
      }
      span:nth-child(2) {
        margin: 0 3px;
        position: relative;
        bottom: -3px;
      }
      span:last-child {
        font-size: 16px;

        font-weight: 500;
      }
    }
  }
  .balance-text-l {
    margin-bottom: 16px;
    span {
      height: 20px;
      font-size: 14px;

      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 20px;
    }
    .btn {
      position: absolute;
      right: 18px;
      cursor: pointer;
      top: 18px;
      width: 53px;
      height: 23px;
      background: rgba(255, 255, 255, 0.33);
      border-radius: 4px;
      height: 20px;
      font-size: 14px;

      font-weight: 500;
      color: #fff;
      line-height: 20px;
      text-align: center;
    }
  }
  .balance-wrap-r {
    flex-wrap: wrap;
    flex: 1;
    & > div {
      // height: 81px;
      margin-top: 23px;
    }
    .title {
      height: 20px;
      font-size: 14px;

      font-weight: 400;
      color: rgba(32, 44, 85, 1);
      line-height: 20px;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      i {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url('../../images/quan.png') no-repeat center;
        background-size: cover;
        margin-right: 3px;
      }
    }
    .price {
      font-size: 14px;
      font-weight: 500;
      color: rgba(24, 24, 24, 1);
      line-height: 25px;
      cursor: zoom-in;
      // cursor:zoom-out;
      margin: 10px 0 0px 19px;
      width: 152px;
    }
  }
  .oil .balance-text {
    background-image: url('../../images/ypzh.png');
  }
  .content-r {
    & > div {
      padding: 18px 20px 26px 20px;
    }
    h2 {
      margin-bottom: 15px;
    }
    li {
      list-style-type: none;
      width: 280px;
      height: 111px;
      border-radius: 10px;
      background: rgba(243, 245, 249, 1);
      padding: 24px 20px;
      justify-content: space-between;
      box-sizing: border-box;
      h3 {
        height: 20px;
        font-size: 14px;
        margin-bottom: 13px;

        font-weight: 400;
        color: rgba(32, 44, 85, 1);
        line-height: 20px;
      }
      .price {
        height: 33px;
        font-size: 24px;

        font-weight: 600;
        color: rgba(18, 28, 64, 1);
        line-height: 33px;
        align-items: flex-end;
        cursor: zoom-in;
        // cursor:zoom-out;
        span:first-child,
        span:last-child {
          font-size: 18px;

          font-weight: 500;
          margin-right: 5px;
        }
        span:last-child {
          font-size: 14px;
          line-height: 28px;
        }
        span:nth-child(2) {
          margin-right: 4px;
        }
      }
    }
    .r {
      margin: 10px;
      h3 {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 20px;

        margin: 20px 20px 13px 3px;
      }
      span {
        display: inline-block;
        font-size: 14px;
        padding: 3px 8px;

        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        width: 80px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        background: rgba(50, 51, 82, 1);
        border-radius: 4px;
        cursor: pointer;
      }
      span:hover {
        background: rgba(50, 51, 82, 0.8);
      }
    }
  }
}
.transform {
  display: inline-block;
  width: 20% !important;
  margin: 0px 10px 0 20px;
}
.matter {
  // border-bottom: 1px solid hsla(233, 13%, 86%, 1);
  // border-top: 1px solid hsla(233, 13%, 86%, 1);
  margin-top: 10px;
  padding: 50px 30px 50px 40px;
}
.titleP {
  font-weight: 650;
  color: rgba(0, 0, 0, 0.647058823529412);
  font-size: 16px;
  line-height: 40px;
}
.titlep {
  font-size: 15px;
  line-height: 29px;
  text-indent: 30px;
  color: rgba(0, 0, 0, 0.647058823529412);
  b {
    color: hsla(221, 71%, 44%, 1);
    cursor: zoom-in;
    // cursor: pointer;
  }
}
.el-dialog__body {
  padding: 0 !important;
}
.el-dialog__footer {
  margin: 0 auto;
  span {
    display: inline-block;
    padding: 10px 30px;
    text-align: center;
    border-radius: 4px;
    color: #fff;
    background: #409eff;
    cursor: pointer;
  }
  .anout {
    color: #666;
    background: #fff;
    margin-left: 30px;
    box-sizing: border-box;
    border: 1px solid rgba(216, 217, 225, 1);
  }
  .blue {
    background: hsla(221, 71%, 44%, 1);
  }
}
.nf-confirm[data-v-6fa96304] {
  .el-dialog__body {
    padding-left: 0 !important;
  }
}
@media screen and (max-width: 1910px) {
  .financial-center {
    .content {
      display: block;
    }
    .balance-wrap-r {
      .price {
        width: 160px;
      }
    }
    .content-r {
      ul {
        height: 245px;
      }
    }
  }
}
</style>
